// Dependencies
import React, {lazy, useEffect}  from 'react';
import {useRef, useState} from 'react';
import {Route, Switch} from 'react-router-dom';
import Login from '../Pages/Login/Login.js';
import UserService from '../Store/UserService';

// import ReportsLayout from '../Components/Layout/ReportsLayout';
// import WelcomePage from '../Pages/WelcomePage/WelcomePage';
// import DashboardLayout from '../Components/Layout/DashboardLayout';

import Utils from '../Store/Utils/Utils';

import MainForm from '../Pages/MainPage/MainPage';
import RegistrationForms from '../Pages/PatientForm/RegistrationForms';
import OnlineBookingMaster from '../Pages/OnlineBooking/OnlineBookingSetupMaster';
import ChooseCoverUser from '../Pages/ChooseCoverUser/chooseCoverUser';
import CustomerInformation from '../Pages/CustomerInformationPage/CustomerInformationPage';
import ReportsPage from '../Pages/Reports/ReportsPage';
import RecallDetailsPage from '../Pages/Reports/RecallDetailsPage';
import RemindersPage from '../Pages/Reports/RemindersPage';
import AppointmentsPage from '../Pages/Reports/AppointmentsPage';
import CancellationPage from '../Pages/Reports/CancellationPage';
import OrdersPage from '../Pages/Reports/OrdersPage';
import VisitsPage from '../Pages/Reports/VisitsPage';
import PurchaseRecapturePage from '../Pages/Reports/PurchaseRecapturePage';
import WelcomePage from '../Pages/WelcomePage/WelcomePage';

import CommunicationsTab from '../Pages/CommunicationsTab/CommunicationsTab.js';
import ReportsTab from '../Pages/ReportsTab/ReportsTab.js';
import SetupTab from '../Pages/SetupTab/SetupTab.js';

// import RouteHandler from './RouteHandler.js';

// Components


/**
 * Remove per conflict on master
 <Route
 path={["/customer"]}
 component={CustomerInformationPage} />
 */

//  const importView = path =>
//   lazy(() =>
//     import(`../${path}`).catch((e) => {
//         console.log(e);
//         console.log(path);
//         import(`../Pages/FourZeroFourPage/FourZeroFourPage`);
//       }
//     )
//   );

 const AppRouter = () => {
  let navbar = useRef();
  
  // const onRender = (e, path) => {
  //   const View = importView(path);
  //   return (
  //     //<React.Suspense fallback={<div>Loading...</div>}>
  //       <View {...e} />
  //     //</React.Suspense>
  //   );
  // }

  // const [menuItems, setMenuItems] = useState([]);

  const onCloseMenu = (e) => {
    if (Utils.getAgent() === 'iOS' || Utils.getAgent() === 'android') {
      if (e.target?.classList.contains('nav-toggle')) {
        navbar.current[0]?.classList.toggle('open');
      } else {
        navbar.current[0]?.classList.remove('open');
      }
    }
  }

  useEffect(() => {
    if (document) {
      navbar.current = document.getElementsByTagName('nav');
    }
  }, []);

  return (
    <>
      <div className='split-pane pane-right'>
          <div className='container no-gutter' onClick={onCloseMenu}>
            <Switch>
              <Route
                exact
                path={["/"]}
                component={Login}
                />
              {/* <Route
                path={'/setup/patient-forms'}
                render={(e) => onRender(e, '../Pages/MainPage/MainPage')}/> */}
              <Route
                exact
                path={['/communications']}
                component={CommunicationsTab}/>
              <Route
                exact
                path={['/reports']}
                component={ReportsTab}/>
              <Route
                exact
                path={['/setup']}
                component={SetupTab}/>
              <Route
                path={['/communications/chat']}
                component={MainForm}/>
              <Route
                path={['/setup/patient-forms']}
                component={RegistrationForms}/>
              <Route
                path={['/setup/online-booking']}
                component={OnlineBookingMaster}/>
              <Route
                path={['/reports/recall-overview']}
                component={ReportsPage}/>
              <Route
                path={['/reports/recall-detail']}
                component={RecallDetailsPage}/>
              <Route
                path={['/reports/reminders']}
                component={RemindersPage}/>
              <Route
                path={['/reports/appointments']}
                component={AppointmentsPage}/>
              <Route
                path={['/reports/cancellation']}
                component={CancellationPage}/>
              <Route
                path={['/reports/orders']}
                component={OrdersPage}/>
              <Route
                path={['/reports/visits']}
                component={VisitsPage}/>
              <Route
                path={['/reports/purchase-recapture']}
                component={PurchaseRecapturePage}/>
              <Route
                path={['/customer']}
                component={CustomerInformation}/>
              <Route
                path={['/chooseCoverUser']}
                component={ChooseCoverUser}/>
              <Route
                path={['/welcome']}
                component={WelcomePage}/>
              <Route
                path={["/logout"]}
                render={() => {
                  UserService.removeUserData();
                  window.location = '/';
                  return <Login/>;
                }
                }/>
              <Route component={WelcomePage}/>
            </Switch>
          </div>
      </div>
    </>
    // <Switch>
    //   <Route
    //     exact
    //     path={["/recall-report"]}
    //     component={ReportsLayout}
    //     />
    //   <Route
    //     path={['/', '/chat', '/registration', '/onlinebooking', '/customer', '/chooseCoverUser', '/logout']}
    //     render={(e) => onRender(e)}
    //     />
    // </Switch>
    // <Switch>
    //   <Route
    //     exact
    //     path={["/recall-report"]}
    //     component={ReportsLayout}
    //     />
    //   <Route
    //     path={['/', '/communications/chat', '/registration', '/onlinebooking', '/customer', '/chooseCoverUser', '/logout']}
    //     component={DashboardLayout}/>
    // </Switch>
  );
  }

  export default AppRouter;